(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fs-product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__fsProductCardInitialized) return;
    window.__fsProductCardInitialized = true;

    const parseBool = (value) => !(value === 'false' || value === false);

    const wait = (ms) =>
      new Promise((resolve) => {
        window.setTimeout(resolve, ms);
      });

    const addToCart = async ({ variantId, quantity }) => {
      const data = {
        id: String(variantId),
        quantity: String(quantity),
      };

      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        let message = 'Unable to add this product to cart.';
        try {
          const err = await response.json();
          message = err.description || err.message || message;
        } catch {}
        throw new Error(message);
      }
    };

    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-fs-product-card-add]');
      if (!button) return;
      if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

      const variantId = Number(button.getAttribute('data-variant-id') || 0);
      const quantity = Number(button.getAttribute('data-quantity') || 1);
      const addingDuration = Number(button.getAttribute('data-adding-duration') || 800);
      const openDrawer = parseBool(button.getAttribute('data-open-drawer'));

      if (!variantId || button.classList.contains('is-adding')) return;

      button.classList.add('is-adding');
      const startedAt = Date.now();

      try {
        await addToCart({ variantId, quantity });

        const elapsed = Date.now() - startedAt;
        if (elapsed < addingDuration) {
          await wait(addingDuration - elapsed);
        }

        button.classList.remove('is-adding');

        document.dispatchEvent(
          new CustomEvent('fs:cart:add', {
            bubbles: true,
            detail: { open: openDrawer, trigger: button },
          })
        );
      } catch (error) {
        button.classList.remove('is-adding');
        console.error(error);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
